import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MessageService } from '../../../services/message.service';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {
    count = 0;
    constructor(private messageServ: MessageService) { }

    ngOnInit() {
        Observable.interval(1000 * 60)
            .merge(Observable.of(true))
            .merge(this.messageServ.updateCount$)
            .filter(x => {
                const token: string = sessionStorage.getItem('token') || '';
                return token.length > 0;
            })
            .switchMap(res => {
                return this.messageServ.newCount();
            }).subscribe(res => this.count = res.num);
    }


}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/message/message.component.ts